import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=50fbdf33&scoped=true"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"
import style0 from "./Release.vue?vue&type=style&index=0&id=50fbdf33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbdf33",
  null
  
)

export default component.exports